document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-gallery-carousel]').forEach(function (gallery) {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = gallery.querySelectorAll('[data-gallery-slide]');
    const prevBtn = gallery.querySelector('[data-gallery-prev]');
    const nextBtn = gallery.querySelector('[data-gallery-next]');
    const dotsContainer = gallery.querySelector('[data-gallery-dots]');
    const viewport = gallery.querySelector('[data-gallery-viewport]');

    const totalSlides = slides.length;
    if (totalSlides <= 1 || !track || !viewport) return;

    let currentIndex = 0;

    function getItemsPerView() {
      const width = window.innerWidth;
      if (width >= 990) return 3;
      if (width >= 750) return 2;
      return 1;
    }

    function getMaxIndex() {
      const itemsPerView = getItemsPerView();
      return Math.max(0, totalSlides - itemsPerView);
    }

    function layoutSlides() {
      const w = viewport.getBoundingClientRect().width;
      const ipv = getItemsPerView();
      const slideW = w / ipv;
      slides.forEach(function (slide) {
        slide.style.flexBasis = slideW + 'px';
        slide.style.width = slideW + 'px';
        slide.style.maxWidth = slideW + 'px';
      });

      const stage = gallery.querySelector('.whats-new-gallery__stage');
      const firstImage = gallery.querySelector('.whats-new-gallery__image-wrapper');
      if (stage && firstImage && gallery.classList.contains('whats-new-gallery--article-ui')) {
        const stageRect = stage.getBoundingClientRect();
        const imageRect = firstImage.getBoundingClientRect();
        const imageCenter = imageRect.top - stageRect.top + imageRect.height / 2;
        stage.style.setProperty('--gallery-nav-center', imageCenter + 'px');
      }
    }

    function rebuildDots() {
      if (!dotsContainer) return;
      const maxIdx = getMaxIndex();
      dotsContainer.innerHTML = '';
      if (maxIdx === 0) {
        dotsContainer.hidden = true;
        return;
      }
      dotsContainer.hidden = false;
      for (let i = 0; i <= maxIdx; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className =
          'whats-new-gallery__dot' + (i === currentIndex ? ' whats-new-gallery__dot--active' : '');
        btn.setAttribute('data-gallery-dot', String(i));
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        btn.addEventListener('click', function () {
          currentIndex = i;
          updateGallery();
        });
        dotsContainer.appendChild(btn);
      }
    }

    function updateGallery() {
      const w = viewport.getBoundingClientRect().width;
      const ipv = getItemsPerView();
      const slideW = w / ipv;
      const maxIdx = getMaxIndex();
      if (currentIndex > maxIdx) currentIndex = maxIdx;

      track.style.transform = 'translateX(-' + currentIndex * slideW + 'px)';

      if (prevBtn) {
        prevBtn.disabled = currentIndex === 0;
        prevBtn.style.opacity = currentIndex === 0 ? '0.35' : '1';
      }

      if (nextBtn) {
        const atEnd = currentIndex >= maxIdx;
        nextBtn.disabled = atEnd;
        nextBtn.style.opacity = atEnd ? '0.35' : '1';
      }

      if (dotsContainer && !dotsContainer.hidden) {
        dotsContainer.querySelectorAll('[data-gallery-dot]').forEach(function (dot, index) {
          dot.classList.toggle('whats-new-gallery__dot--active', index === currentIndex);
        });
      }
    }

    function nextSlide() {
      if (currentIndex < getMaxIndex()) {
        currentIndex++;
        updateGallery();
      }
    }

    function prevSlide() {
      if (currentIndex > 0) {
        currentIndex--;
        updateGallery();
      }
    }

    function onResize() {
      layoutSlides();
      rebuildDots();
      updateGallery();
    }

    if (nextBtn) nextBtn.addEventListener('click', nextSlide);
    if (prevBtn) prevBtn.addEventListener('click', prevSlide);

    layoutSlides();
    rebuildDots();
    updateGallery();

    window.addEventListener('resize', function () {
      onResize();
    });

    let startX = 0;
    let isDragging = false;

    track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });

    track.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
    });

    track.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;

      const endX = e.changedTouches[0].clientX;
      const diffX = startX - endX;
      const threshold = 50;

      if (Math.abs(diffX) > threshold) {
        if (diffX > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }
    });
  });
});
